export default {
  search: {
    filter: {
      price: 'Precio Ítem',
    },
    result: {
      empty: 'No se han encontrado registros',
    },
    script: {
      components: {
        price_filter: {
          script: {
            computed: {
              label1: 'Todos',
              label2: 'Sólo ítems con precio mayor a 0',
              label3: 'Sólo ítems con precio 0',
            },
          },
        },
        status_filter: {
          script: {
            computed: {
              label1: 'Todos',
              label2: 'Sólo ítems publicados',
              label3: 'Sólo ítems sin publicar',
            },
          },
        },
        /*
          *CatalogItemLoader did not require translation
          *CatalogItemCard did not require translation
        */
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/catalog/search.js